import { openTripsOf, TripLike } from './listingHold';

/**
 * Paused host (D41): what a brand admin can do with one open trip of a host on
 * the admin Hosts page. Booked trips go ahead when a host is paused; the admin
 * may cancel a future trip (not started, nobody checked in) with a full refund,
 * but only once the host is paused, since the server refuses it otherwise.
 */
export type PausedHostTripAction = 'cancel' | 'pauseFirst' | 'inProgress' | null;

export function pausedHostTripAction(
  trip: TripLike,
  hostPaused: boolean,
  now: number,
): PausedHostTripAction {
  if (trip.status !== 'BOOKED' && trip.status !== 'SHORTENED') return null;
  if (trip.hostFinishedCheckout || trip.endAt <= now) return null;
  const started = trip.startAt <= now || trip.hostFinishedCheckin || trip.guestFinishedCheckin;
  if (started) return 'inProgress';
  return hostPaused ? 'cancel' : 'pauseFirst';
}

export { openTripsOf };

/** "3 open trips" / "1 open trip" for the host row; null when there are none. */
export function openTripsLabel(count: number | null | undefined): string | null {
  if (!count || count <= 0) return null;
  return `${count} open trip${count === 1 ? '' : 's'}`;
}

/** The toast after pausing a host: names the trips that still go ahead. */
export function pauseHostToast(label: string, openTripCount: number | null | undefined): string {
  const base = `${label} is paused on this brand.`;
  if (!openTripCount || openTripCount <= 0) return base;
  const trips = `${openTripCount} booked trip${openTripCount === 1 ? '' : 's'}`;
  return `${base} ${trips} go${openTripCount === 1 ? 'es' : ''} ahead; cancel them from Trips if needed.`;
}
